import React, { useEffect, useState } from 'react'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'
import styles from './devicesTags.jcss'
import translate from '../../../core/translate'
import EditText from '../../../blocks.simple/editText/editText'
import { api } from '../../../core/api/ConnectionManager'

export type Tag = {
    id: number
    name: string
    totalDevicesCount: number
}

export const DevicesTags = ({
    selectedTags,
    onSelectTag,
    onSelectAllTags,
    groupIds,
}: {
    selectedTags: Tag[]
    onSelectTag: (tag: Tag) => void
    onSelectAllTags: (tags: Tag[]) => void
    groupIds: number[]
}) => {
    const [tags, setTags] = useState<Tag[]>([])
    const [search, setSearch] = useState<string>('')

    const getTags = () => {
        api.send('getTagsByGroupId', {
            groupIds,
            query: search,
        }).then((res: any) => {
            if (!res) return

            setTags(res)
        })
    }

    useEffect(() => {
        const timeout = setTimeout(getTags, 300)

        return () => clearTimeout(timeout)
    }, [search])

    return (
        <div className={styles.devicesTags}>
            <div className={styles.search}>
                <EditText
                    value={search}
                    onChange={setSearch}
                    icon={search ? 'close' : 'search'}
                    iconSize={20}
                    onIconClick={() => {
                        if (search) {
                            setSearch('')
                        }
                    }}
                    placeholder={translate('enterTagName')}
                />
            </div>
            <table className={styles.table}>
                <tbody>
                    <tr>
                        <th className={styles.checkboxCol}>
                            <Checkbox
                                checked={selectedTags.length === tags.length}
                                onClick={(checked: boolean) => onSelectAllTags(checked ? tags : [])}
                            />
                        </th>
                        <th className={styles.nameCol}>{translate('tagName')}</th>
                        <th className={styles.devicesCol}>{translate('deviceQuantityWithTag')}</th>
                    </tr>
                    {tags && tags.length
                        ? tags.map((tag) => (
                              <tr>
                                  <td className={styles.checkboxCol}>
                                      <Checkbox
                                          checked={selectedTags.some((item) => item.id === tag.id)}
                                          onClick={(checked: boolean) => onSelectTag(tag)}
                                      />
                                  </td>
                                  <td className={styles.nameCol}>{tag.name}</td>
                                  <td className={styles.devicesCol}>{tag.totalDevicesCount}</td>
                              </tr>
                          ))
                        : null}
                </tbody>
            </table>
        </div>
    )
}
